import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';
import { SERVICE_ENDPOINTS } from '../../core/configs/service-endpoints';
import { ServiceResult } from '../../core/interfaces/service-result';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { TransactionData } from '../interfaces/transaction/transaction-data';
import { TransactionQueryConfig } from '../interfaces/transaction/transaction-query-config';

@Injectable({
  providedIn: 'root'
})
export class TransactionDataService extends BaseCrudService<TransactionData, TransactionData> {

  baseUrl = this.runtimeConfig.transactionSearchBackend;
  selectedOrganisationId: string;
  selectedOrganisationName: string;


  constructor() {
    super();
  }

  /**
   * loading table config from local resources asynchronous
   * @param configId
   */
  getQueryParamConfig(configId: string): Observable<TransactionQueryConfig> {
    const endpoint: string = 'configs/query-params/' + configId + '.json';
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<TransactionQueryConfig>(endpoint, {headers});
  }

  /**
   * get data with LazyLoading-Params (paging)
   * @param lazyLoadEvent
   * @param status
   */
  findPage(lazyLoadEvent: LazyLoadEvent, status: string = null): Observable<ServiceResult> {
    let params = new HttpParams().set('search', JSON.stringify(lazyLoadEvent));
    if (status) {
      params = params.append('status', status);
    }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + SERVICE_ENDPOINTS.GET_TRANSACTIONS, {headers, params});
  }

  /**
   * get data with LazyLoading-Params (paging) for a specific tenant (as SUPER-ADMIN)
   * @param lazyLoadEvent
   * @param tenantId
   * @param status
   */
  findTenantPage(lazyLoadEvent: LazyLoadEvent, tenantId: string, status: string = null): Observable<ServiceResult> {
    let params = new HttpParams().set('search', JSON.stringify(lazyLoadEvent));
    if (status) {
      params = params.append('status', status);
    }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + SERVICE_ENDPOINTS.GET_TRANSACTIONS_TENANT + tenantId, {headers, params});
  }

  /**
   * get latest transactions from backend (for dashboard)
   * @param searchParams
   */
  getLatestTransactions(searchParams: TransactionQueryConfig): Observable<ServiceResult> {
    let params = new HttpParams().set('search', JSON.stringify(searchParams.search));
    params = params.append('status', searchParams.status);
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + SERVICE_ENDPOINTS.GET_TRANSACTIONS, {headers, params});
  }

}
